import React from "react";

import ImgShapeContainer from "../ImgShape";

const CrossSelling = ({ text, link, side, image }) => {
    return (
        <ImgShapeContainer
            headlineNumber="3"
            {...{
                text,
                image,
                link,
                side,
                gtag: "crossselling:general",
                imageMirroring: false,
                hasTextOutline: true,
            }}
        />
    );
};

export default CrossSelling;
